import React from 'react';
import { BoxCheckIcon, Heading, Paragraph } from '@quickmd-llc/design-system';

export const AllSetEmptyState: React.FC = () => {
  return (
    <div className="flex min-h-[400px] w-full flex-col items-center justify-center gap-sp-1 rounded-[8px] border border-border-medium bg-white">
      <BoxCheckIcon iconSize="xl" className="text-text-light" />
      <Heading level="h3" className="text-text-dark">
        All Set!
      </Heading>
      <Paragraph className="text-text-medium">Your visits will appear here.</Paragraph>
    </div>
  );
};
